import { render, staticRenderFns } from "./PositionAdvertisements.vue?vue&type=template&id=340bb7f1&scoped=true&"
import script from "./PositionAdvertisements.vue?vue&type=script&lang=js&"
export * from "./PositionAdvertisements.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/advertise/PositionAdvertisements/PositionAdvertisementsStyle.css?vue&type=style&index=0&id=340bb7f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340bb7f1",
  null
  
)

export default component.exports